import { FC } from 'react';
import { TableRow, TableCell, Box, Tooltip } from '@mui/material';
import { RecipeComponent } from '../../../../app/services/api/generated';
import RoundAndFormatValue from '../../../../components/shared/RoundAndFormatValue';
import { formatNumber } from '../../../../utils';
import UpdateIcon from '@mui/icons-material/Update';
import { useTranslation } from 'react-i18next';

type Props = {
  item: RecipeComponent;
  currencyCode?: string;
}

const IngredientRow: FC<Props> = ({ item, currencyCode }) => {
  const { t } = useTranslation('common');
  return (
    <TableRow
      key={`{${item.componentId}}` }
    >
      <TableCell>
        {item.componentId}
      </TableCell>
      <TableCell>
        {item.componentItemNumber}
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {item.componentNewItemNumber && (
            <Tooltip
              title={t('inTransition', { newItemNumber: item.componentNewItemNumber })}
              slotProps={{ tooltip: { sx: { maxWidth: 'none', whiteSpace: 'nowrap' } } }}
            >
              <UpdateIcon sx={{ fontSize: 18, mr: 1, mb: 2 }} />
            </Tooltip>
          )}
          {item.componentDescription}
        </Box>
      </TableCell>
      <TableCell>
        {Number(item.weight).toFixed(2)}
      </TableCell>
      <TableCell>
        {formatNumber(item.quantity)}
      </TableCell>
      <TableCell>
        {<RoundAndFormatValue
          value={item.componentCostPriceOnHand ?? 0}
          currencyCode={currencyCode} />}
      </TableCell>
    </TableRow>
  );
};

export default IngredientRow;